/* ============================================================
   BONHEUR - Pie del cajon de navegacion
   BigStudio 2026

   Clona el bloque declarado en snippets/bonheur-menu-pie.liquid
   dentro del cajon de navegacion de Horizon, sin editar el
   snippet de 60 KB del tema. Asi el tema se puede actualizar sin
   volver a aplicar el parche, y si este archivo no carga el menu
   queda exactamente como estaba.

   DOS COSAS QUE SE APRENDIERON PROBANDO
   1. Nada de temporizador de seguridad. La primera version
      apagaba el observador a los 30 segundos: si la clienta abre
      el menu al minuto, el bloque ya no aparecia.
   2. Nada de bandera de "ya esta hecho". Horizon vuelve a dibujar
      el cajon despues de cargar y se lleva puesto el bloque; con
      la bandera puesta nunca se reponia. La unica fuente de
      verdad es el DOM: si el bloque no esta, se pone de nuevo.

   El observador queda vivo toda la sesion a proposito, pero su
   trabajo por mutacion es una sola consulta al DOM y va agrupado
   en un requestAnimationFrame, asi que no compite con el
   desplazamiento.
   ============================================================ */

(function () {
  'use strict';

  var PLANTILLA = 'bh-menu-pie';

  /* De mas interno a mas externo: se cuelga justo despues de la
     lista de enlaces, no al final de todo el cajon. */
  var DESTINOS = [
    '.menu-drawer__menu',
    '.menu-drawer__menu-list',
    '.header-drawer__menu',
    '.menu-drawer__navigation',
    '.menu-drawer'
  ];

  function pintar() {
    /* La verdad la tiene el DOM, no una variable. */
    if (document.querySelector('.bh-menupie')) return;

    var tpl = document.getElementById(PLANTILLA);
    if (!tpl || !tpl.content) return;

    var destino = null, i, cont;
    for (i = 0; i < DESTINOS.length; i++) {
      cont = document.querySelector(DESTINOS[i]);
      if (cont && cont.parentElement) { destino = cont; break; }
    }
    if (!destino) return;

    destino.parentElement.insertBefore(tpl.content.cloneNode(true), destino.nextSibling);
  }

  function arrancar() {
    pintar();

    if ('MutationObserver' in window) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(function () {
          pendiente = false;
          pintar();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* Red de seguridad para el caso en que el cajon ya exista y no
       haya mutacion alguna que escuchar. */
    document.addEventListener('click', function () {
      window.setTimeout(pintar, 80);
    }, { passive: true, capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', pintar);
})();
